import { FormEvent, useState } from 'react';
import { changePassword } from '../api';
import { useAuth } from '../auth';
import { useT } from '../i18n';
import Notice from '../components/Notice';
import Wordmark from '../components/Wordmark';

/** Shown full-screen when the account still has a temporary password; also reused inside Settings. */
export default function ChangePassword({ forced = false }: { forced?: boolean }) {
  const { setUser, signOut } = useAuth();
  const { t } = useT();
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [ok, setOk] = useState(false);
  const [busy, setBusy] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null); setOk(false);
    if (next !== confirm) { setError(t('pw.mismatch')); return; }
    setBusy(true);
    try {
      const r = await changePassword(current, next);
      setUser(r.user); setOk(true);
      setCurrent(''); setNext(''); setConfirm('');
    } catch (err) { setError((err as Error).message); }
    finally { setBusy(false); }
  }

  const form = (
    <form onSubmit={onSubmit} className="space-y-4">
      <div><label className="label" htmlFor="cur">{forced ? t('pw.temp') : t('pw.current')}</label>
        <input id="cur" type="password" autoComplete="current-password" value={current} onChange={(e) => setCurrent(e.target.value)} required /></div>
      <div><label className="label" htmlFor="new">{t('pw.new')}</label>
        <input id="new" type="password" autoComplete="new-password" minLength={8} value={next} onChange={(e) => setNext(e.target.value)} required /></div>
      <div><label className="label" htmlFor="conf">{t('pw.repeat')}</label>
        <input id="conf" type="password" autoComplete="new-password" minLength={8} value={confirm} onChange={(e) => setConfirm(e.target.value)} required /></div>
      {error && <Notice kind="error">{error}</Notice>}
      {ok && <Notice kind="success">{t('pw.updated')}</Notice>}
      <button className="btn-primary w-full" disabled={busy}>{busy ? t('pw.busy') : t('pw.submit')}</button>
    </form>
  );

  if (!forced) return form;
  return (
    <div className="min-h-dvh flex items-center justify-center p-6">
      <div className="card w-full max-w-sm p-6 space-y-5">
        <Wordmark />
        <div><h1 className="text-xl font-semibold">{t('pw.title')}</h1><p className="text-dim text-sm mt-1">{t('pw.blurb')}</p></div>
        {form}
        <button type="button" className="btn-ghost w-full" onClick={signOut}>{t('login.signout')}</button>
      </div>
    </div>
  );
}
